













import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class Results extends Vue {
  private get hpurl(): string {
    return (
      "https://hyperproof.io/quiz-final-page-2/?fw=" +
      Array.from(this.$store.getters.mergedFrameworks)
        .sort()
        .join(",")
    );
  }
}
